import {
  ProteinInfoDTO,
  IncubationTempDTO,
  ExperimentInfo,
  ScreenExperimentTemplateDTO,
  ImagingScheduleInfoDTO,
  OwnerInfoDTO,
} from './../../../business/models/Models';
import { ScreenInfoDTO, PlateTypeDTO } from 'business/models/Models';

import React from 'react';

type TScreenWizard = {
  screens: ScreenInfoDTO[];
  changeScreens: (e: ScreenInfoDTO[]) => void;
  proteins: ProteinInfoDTO[];
  changeProteins: (e: ProteinInfoDTO[]) => void;
  incubationTemp: number[];
  setIncubationTemp: (e: number[]) => void;
  plateType: PlateTypeDTO;
  setPlateType: (e: PlateTypeDTO) => void;
  imagingSchedule: ImagingScheduleInfoDTO;
  setImagingSchedule: (e: ImagingScheduleInfoDTO) => void;
  owner: OwnerInfoDTO;
  setOwner: (e: OwnerInfoDTO) => void;
  expNameSuffix: string;
  setExpNameSuffix: (e: string) => void;
  expNamePrefix: string;
  setExpNamePrefix: (e: string) => void;
  expNameFormatString: string;
  setExpNameFormatString: (e: string) => void;
  createNewExp: boolean;
  setCreateNewExp: (e: boolean) => void;
  allTemps: IncubationTempDTO[];
  setAllTemps: (e) => void;
  expTemplate: string;
  setExpTemplate: (e: string) => void;
  saveScreenExpTemplate: (val) => any;
  wizardDataDirty: boolean;
  setWizardDataDirty: (val: boolean) => void;
  templateData: ScreenExperimentTemplateDTO;
  setTemplateData: (val: ScreenExperimentTemplateDTO) => void;
  experimentInfoList: ExperimentInfo[];
  expSaveLocation: number;
  setExpSaveLocation: (val: number) => void;
  setScreenVolError: (val: boolean) => void;
  setProteinVolError: (val: boolean) => void;
  setExpNameError: (val: boolean) => void;
  templateNames: string[];
  setTemplateNames: (val: string[]) => void;
  createExpPath: string;
  setCreateExpPath: (val: string) => void;
  explorerBroadcastChannel: BroadcastChannel;
};

const ScreenWizardContext = React.createContext<TScreenWizard>({
  screens: null,
  changeScreens: (e) => {},
  proteins: [],
  changeProteins: (e) => {},
  incubationTemp: [],
  setIncubationTemp: (e) => {},
  plateType: null,
  setPlateType: (e) => {},
  imagingSchedule: null,
  setImagingSchedule: (e) => {},
  owner: null,
  setOwner: (e) => {},
  expNameSuffix: '',
  setExpNameSuffix: (e) => {},
  expNamePrefix: '',
  setExpNamePrefix: (e) => {},
  expNameFormatString: '',
  setExpNameFormatString: (e) => {},
  createNewExp: true,
  setCreateNewExp: (e) => {},
  allTemps: [],
  setAllTemps: (e) => {},
  expTemplate: null,
  setExpTemplate: (e) => {},
  saveScreenExpTemplate: (val) => {},
  wizardDataDirty: false,
  setWizardDataDirty: (val) => {},
  templateData: null,
  setTemplateData: (val) => {},
  experimentInfoList: [],
  expSaveLocation: null,
  setExpSaveLocation: (val) => {},
  setScreenVolError: (val) => {},
  setProteinVolError: (val) => {},
  setExpNameError: (val) => {},
  templateNames: [],
  setTemplateNames: (val) => {},
  createExpPath: '',
  setCreateExpPath: (val) => {},
  explorerBroadcastChannel: null,
});

export default ScreenWizardContext;
